import { MEDIA_ERROR_CODES } from '../MediaUpload';

export interface VideoData {
    height: number;
    width: number;
    mimetype: string;
    thumbnail: string;
    duration: number;
}

export const getVideoMetadata = async (video: File): Promise<VideoData> => {
    return new Promise(async (resolve, reject) => {
        const videoUrl = URL.createObjectURL(video);

        const videoElement = document.createElement('video');
        videoElement.src = videoUrl;
        videoElement.currentTime = 1;

        videoElement.onloadeddata = () => {
            const canvas = document.createElement('canvas');
            canvas.width = videoElement.videoWidth;
            canvas.height = videoElement.videoHeight;
            const context = canvas.getContext('2d');
            context?.drawImage(videoElement, 0, 0, canvas.width, canvas.height);
            const imageDataUrl = canvas.toDataURL('image/png');

            const width = videoElement.videoWidth;
            const height = videoElement.videoHeight;
            const duration = videoElement.duration;
            const mimetype = video.type;

            // Free up memory by revoking object URL
            URL.revokeObjectURL(videoUrl);

            resolve({
                duration,
                height,
                mimetype,
                thumbnail: imageDataUrl,
                width,
            });
        };

        videoElement.onerror = () => {
            reject({ code: MEDIA_ERROR_CODES.UNSUPPORTED_TYPE });
        };
    });
};
